import React from 'react'

export const Audits = () => {
  return (
    <div>Audits</div>
  )
}
